import React, { createContext, useContext } from 'react';

import { useSelector } from 'react-redux';

import { emptyArray, emptyObject } from 'ui-components/default-props/empty';
import { ChildrenPropType } from '../../../../prop-types/children';
import { sortByPropAsc } from '../../../../services/sort-service';
import Global from '../../../../store/global-selectors';
import { useSalesOrderIdContext } from '../../../context/sales-order-id-context-provider';

const ShipmentsPanelContext = createContext(emptyArray);

export const useShipmentsPanelContext = () => useContext(ShipmentsPanelContext);

export const ShipmentsPanelContextProvider = ({ children }) => {
  const salesOrderId = useSalesOrderIdContext();

  const value = useSelector((state) => {
    const salesOrder = Global.selectEntitiesSalesOrderById(state, { salesOrderId }) || emptyObject;
    const fulfillmentPlanIds = salesOrder.fulfillmentPlanIds || emptyArray;
    const unsortedFulfillmentPlans =
      Global.selectEntitiesFulfillmentPlansByIds(state, {
        fulfillmentPlanIds,
      }) || emptyArray;

    let fulfillmentPlanCounter = 1;

    return unsortedFulfillmentPlans.sort(sortByPropAsc('createDateTime')).map((fulfillmentPlan) => {
      const { fulfillmentPlanId, orderGridStatus, rateSummary } = fulfillmentPlan;
      const { rate } = rateSummary;
      return {
        fulfillmentPlanId,
        counter: fulfillmentPlanCounter++,
        orderGridStatus,
        shippingCost: rate?.shippingCost,
      };
    });
  });

  return <ShipmentsPanelContext.Provider value={value}>{children}</ShipmentsPanelContext.Provider>;
};

ShipmentsPanelContextProvider.propTypes = {
  children: ChildrenPropType.isRequired,
};
